var map = {
	"./alerta-icon-filled.png": 465,
	"./alerta-icon.png": 464,
	"./avatars/man/doctor.svg": 472,
	"./avatars/man/graduate.svg": 473,
	"./avatars/man/master.svg": 474,
	"./avatars/man/student.svg": 475,
	"./avatars/man/teacher.svg": 476,
	"./avatars/user.svg": 477,
	"./avatars/woman/female_doctor.svg": 478,
	"./avatars/woman/female_graduate.svg": 479,
	"./avatars/woman/female_master.svg": 480,
	"./avatars/woman/female_student.svg": 481,
	"./avatars/woman/female_teacher.svg": 482,
	"./backButton.svg": 483,
	"./balao-branco-com-seta.svg": 950,
	"./bg_perfil.svg": 300,
	"./box_classificacao.svg": 298,
	"./carteira.png": 303,
	"./celular-antigo-sms.svg": 951,
	"./celular-simples-sms.png": 306,
	"./classificacao.png": 466,
	"./enterButton.svg": 952,
	"./false.svg": 208,
	"./final-first-of-local-ranking.png": 469,
	"./final-first-of-ranking.png": 468,
	"./final-not-first-of-ranking.png": 470,
	"./flat-pencil-loading.gif": 457,
	"./icon-classificacao-geral.png": 484,
	"./icon-classificacao-local.png": 485,
	"./iphone-messaging-app.png": 953,
	"./lampada_logo.png": 954,
	"./letter.png": 307,
	"./logoFlat.svg": 111,
	"./logoUfjf.png": 486,
	"./logoWhite.png": 487,
	"./mapa-limpo.png": 299,
	"./msg-envelope.png": 488,
	"./notification-bell.png": 955,
	"./pencil-loading.gif": 956,
	"./perfil.png": 467,
	"./pin-biologicas.png": 957,
	"./pin-engenharias.png": 958,
	"./pin-exatas-terra.png": 959,
	"./pin-humnas.png": 960,
	"./pin-letras-artes.png": 961,
	"./pin-saude.png": 962,
	"./pin-sociais-aplicadas.png": 963,
	"./portao-ufjf.png": 964,
	"./prancheta.png": 304,
	"./predio-ufjf.png": 471,
	"./rankings-flat.png": 965,
	"./spinner.gif": 966,
	"./tela-de-apresentacao.png": 302,
	"./true.svg": 207,
	"./ufjfblur.jpeg": 297,
	"./user-icon.png": 967,
	"./vencedor.png": 968,
	"./visao-professor.png": 301,
	"./visualizacao-a3.png": 305
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 949;


//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*$
// module id = 949
// module chunks = 0